import { apiStylesDict } from '@/store/userSettings/apiDicts'

function getColorPalleteKeys() {
  return [
    'range',
    'C',
    'X',
    'F',
    'eveqeqrbl',
    'eveqeqrbl_2',
    'eveqeqrbl_3',
    'R_default',
    'R1',
    'R1_2',
    'R2',
    'R2_2',
    'R3',
    'R3_2',
    'R4',
    'R4_2',
    'diamonds',
    'spades',
    'clubs',
    'hearts',
    'player_ip',
    'player_oop',
    'range_empty',
    'range_active',
    'range_text',
    'combo_text',
    'action_text',
    'combo_range_active',
    'combo_range_empty',
    'card_back',

    'trainer_active_canvas_back',
    'trainer_active_canvas_outline',
    'trainer_active_table_back',
    'trainer_active_table_outline',

    'trainer_canvas_back',
    'trainer_canvas_outline',
    'trainer_table_back',
    'trainer_table_outline',

    'trainer_player_hero',
    'trainer_player_opponent',
    'trainer_player_active',
    'trainer_player_folded',
    'trainer_pattern',
    'trainer_hand_highlight',
    'trainer_action_btn_default_background',
  ]
}

function colorPalettes() {
  const res = [
    // {
    //     id: 'buggy',
    //     owner: 'user',
    //     dev_only: true,
    //     conf: '#3FA593,#FFC54D,#FFC54D,#B10E0E,#F30225,#EDC627,#00D70D,#37AD0C,#103A00,#27431C,#1E7100,#457633,#2EAF00,#6AB54F,#44FF00,#99FF74,#283ac4,#4f4f4f,#08ab27,#8b0901,#00ac8d,#23b5ef,#1e1e1e,#1e1e1e,#f5f5f5,#121212,#f5f5f5,#cfcfcf,#1e1e1e,#2f2f2f,#141414,#1EC39C00,#00000000,#4D4D4D,#121212,#00000000,#00000000,#262626,#00ac8d,#ff8f00,#3f3f3f,#262626,#1e1e1e8F;default,back_logo,two,none,shadow_higher,shadow_drop',
    // },
    {
      id: 'default',
      owner: 'GTO Wizard',
      conf: '#ff8f00,#5ab966,#5ab966,#3D7CB8,#F03C3C,#FFA83D,#59D167,#F03C3C,#f03c3c,#dd3737,#ca3232,#b62e2e,#a32929,#902424,#7d1f1f,#6a1a1a,#2235C5,#504F4F,#0EAD2C,#AD0E04,#25B336,#97EAF8,#1e1e1e,#1e1e1e,#f5f5f5,#121212,#f5f5f5,#cfcfcf,#1e1e1e,#2F2F2F,#141414,#1EC39C00,#00000000,#4D4D4D,#121212,#00000000,#00000000,#262626,#00ac8d,#ff8f00,#3f3f3f,#262626,#1e1e1e8F,#ffb800,#1e1e1e;default_big_symbol,back_logo,two,none,shadow_drop,shadow_drop',
    },
    {
      id: 'tadara',
      owner: 'Tadara',
      conf: '#52A98D,#6AC267,#56B25F,#0D709C,#A71D4C,#CECC55,#6AC267,#C7225B,#c7225b,#b71f54,#a71d4c,#971a45,#87173e,#771437,#67122f,#580f28,#0D709C,#2E2E2E,#6AC267,#C7225B,#6AC267,#CECC55,#1E1E1E,#252525,#f5f5f5,#F3F3F3,#f5f5f5,#2E2E2E,#1E1E1E,#383838,#141414,#1EC39C00,#00000000,#4D4D4D,#121212,#00000000,#00000000,#262626,#00ac8d,#ff8f00,#3f3f3f,#262626,#1e1e1e8F,#ffb800,#1e1e1e;default_big_symbol,back_isometric,one,none,shadow_drop,shadow_drop',
    },

    {
      id: 'ice_cold',
      owner: 'WolfiSpirit',
      conf: '#FFB914,#CCCCCC,#CCCCCC,#2C2C2C,#D8EBEF,#34BAD4,#263252,#34BAD4,#97D5E1,#97D5E1,#34BAD4,#34BAD4,#116897,#116897,#263252,#392148,#1683B9,#424242,#178E5C,#BF3D35,#00E9FF,#FFFFFF,#333333,#666666,#000000,#000000,#f5f5f5,#666666,#333333,#0D435A,#141414,#1EC39C00,#121212FF,#949494,#121212,#00000000,#121212FF,#262626,#00E9FF,#FFB914,#3f3f3f,#262626,#77CDFF29,#ffb800,#1e1e1e;inverted_fancy,back_logo,two,wavy,shadow_higher,shadow_none',
    },
    {
      id: 'pio',
      conf: '#FFFF00,#8FBC8B,#8FBC8B,#6DA2C0,#ED1C24,#65E61D,#FFFFFF,#f55353,#E9967A,#E9967A,#DA886E,#CA7761,#B86350,#B86350,#A3483B,#A3483B,#283ac4,#4F4F4F,#0BAA29,#FA032F,#00ac8d,#23b5ef,#666666,#666666,#000000,#121212,#f5f5f5,#666666,#666666,#2f2f2f,#141414,#1EC39C00,#00000000,#4D4D4D,#121212,#00000000,#00000000,#262626,#00ac8d,#ff8f00,#3f3f3f,#262626,#1e1e1e8F,#ffb800,#1e1e1e;default_downsymbol,back_logo,two,none,shadow_none,shadow_none',
    },

    {
      id: 'homage',
      owner: 'MoreTBC',
      conf: '#BD632F,#386150,#386150,#393E41,#931621,#E6AF2E,#19AF27,#AD2831,#ad2831,#9f252d,#800E13,#800E13,#640D14,#640D14,#38040E,#38040E,#083D77,#42464D,#4D8B31,#BD0F15,#D81E5B,#394053,#0C0C0C,#1e1e1e,#f5f5f5,#FFFFFF,#f5f5f5,#393E41,#0C0C0C,#2f2f2f,#FFFFFF01,#00000000,#163B3B96,#42B3B3,#121212,#00000000,#00000000,#262626FF,#4CB944,#1E6DAE,#A62639,#270722,#191919E8,#ffb800,#1e1e1e;default,back_plain,one,none,shadow_drop,shadow_drop',
    },
    {
      id: 'hot_colors',
      owner: 'supercourgette',
      conf: '#74674F,#62E45A,#71CC6C,#0A92CF,#CB0303,#FFFC6B,#00C925,#FF0058,#F06200,#F03A29,#D91D43,#CD0056,#B90069,#9B007C,#72008D,#2C1499,#283ac4,#4f4f4f,#08ab27,#8b0901,#09F328,#FDF800,#1e1e1e,#1e1e1e,#f5f5f5,#121212,#f5f5f5,#cfcfcf,#1e1e1e,,#141414,#1EC39C00,#00000000,#4D4D4D,#121212,#00000000,#00000000,#262626,#00ac8d,#ff8f00,#3f3f3f,#262626,#1e1e1e8F,#ffb800,#1e1e1e;default_big_symbol,back_logo,two,none,shadow_drop,shadow_drop',
    },
    {
      id: 'wisdom',
      owner: 'Retrodrive',
      conf: '#3FA593,#FFC54D,#FFC54D,#535962,#F30225,#EDC627,#00D70D,#916BBF,#916bbf,#8562b0,#7a5aa0,#6e5191,#634982,#574073,#4b3863,#402f54,#283ac4,#4f4f4f,#08ab27,#8b0901,#00ac8d,#23b5ef,#1e1e1e,#1e1e1e,#f5f5f5,#121212,#f5f5f5,#cfcfcf,#1e1e1e,#2f2f2f,#141414,#1EC39C00,#00000000,#4D4D4D,#121212,#00000000,#00000000,#262626,#00ac8d,#ff8f00,#3f3f3f,#262626,#1e1e1e8F,#ffb800,#1e1e1e;default_plain,back_logo,two,none,shadow_higher,shadow_drop',
    },
    {
      id: 'data_picker_v2',
      owner: 'Batovs',
      conf: '#74674F,#31EA35,#38EC50,#0585BE,#DF0E0E,#AD8600,#0FC932,#FF002D,#F9720C,#CE3C20,#ED2543,#B6044B,#BB0265,#790459,#67036B,#290550,#2831C4,#494848,#07C22B,#A30E05,#00FF22,#FD0101,#1e1e1e,#1e1e1e,#f5f5f5,#121212,#f5f5f5,#cfcfcf,#1e1e1e,#494645,#141414,#13786100,#A1060600,#C2C2CD,#141414,#4C4A4A00,#0D0D0D00,#272525,#00FF22,#FD2B01,#3f3f3f,#262626,#1e1e1e8F,#ffb800,#1e1e1e;default_big_symbol,back_logo,two,jigsaw,shadow_drop,shadow_drop',
    },
    {
      id: 'ital',
      owner: 'Georgi',
      conf: '#EDC951,#27C27D,#C5A881,#3C91A3,#DC564E,#428AA9,#21B31D,#DB323F,#E9838B,#ED3544,#D35D65,#A01C26,#B83B45,#6B1219,#65171D,#520E13,#00AEDB,#424141,#00B159,#D11141,#F9CAA7,#35A79C,#4F5B66,#4F5B66,#E3E6EC,#121212,#f5f5f5,#99B898,#2A363B,#03C08A,#594F4F88,#8C9978FF,#3D575CFF,#8DE900FF,#242121FF,#547980FF,#547980CE,#547980FF,#0392CFFF,#DA1A0EFF,#F37736FF,#594F4FFF,#00FAD709,#ffb800,#1e1e1e;default_thick2,back_logo,one,trianglemadness,shadow_outlined,shadow_drop',
    },
    {
      id: 'pickaxe',
      owner: 'David',
      conf: '#FF6901,#008000,#008080,#000080,#800000,#808000,#008000,#800000,#808000,#804000,#804000,#800000,#800000,#800040,#800040,#800080,#1E86BF,#3B3B3B,#3A992C,#E22621,#00FF00,#FF0000,#000000,#000000,#FFFFFF,#FFFFFF,#f5f5f5,#000000,#000000,#FF6901,#000000,#00FF00FF,#FFFFFF80,#FFFFFF,#000000,#FF0000FF,#FFFFFF80,#FFFFFF,#00FF00,#FF0000,#FF6901,#803400,#FFFFFF80,#ffb800,#1e1e1e;default,back_logo,two,gwiz,shadow_none,shadow_none',
    },
    {
      id: 'easter',
      owner: 'Pete',
      conf: '#ff8f00,#5ab966,#5ab966,#3b809b,#CB0303,#FFFC6B,#00C925,#F1683A,#FFF1A8,#DECD35,#FFC16A,#EB9214,#FF8585,#DA1C1C,#B593FF,#6418CB,#283ac4,#4f4f4f,#08ab27,#8b0901,#00ac8d,#23b5ef,#1e1e1e,#1e1e1e,#000000,#121212,#f5f5f5,#cfcfcf,#1e1e1e,#2f2f2f,#141414,#1EC39C00,#00000000,#4D4D4D,#121212,#00000000,#00000000,#262626,#00ac8d,#ff8f00,#3f3f3f,#262626,#1e1e1e8F,#ffb800,#1e1e1e;inverted_thick,back_logo,one,none,shadow_drop,shadow_drop',
    },
    {
      id: 'colorblinds_arise',
      owner: 'Shokyu',
      conf: '#74674F,#62E45A,#71CC6C,#0A92CF,#CB0303,#FFFC6B,#00C925,#FF0058,#F06200,#F03A29,#CD0056,#D91D43,#72008D,#2C1499,#B90000,#9B0059,#283ac4,#4f4f4f,#08ab27,#8b0901,#0942F3,#FDF800,#1e1e1e,#1e1e1e,#f5f5f5,#121212,#f5f5f5,#cfcfcf,#1e1e1e,#2f2f2f,#141414,#1EC39C00,#00000000,#4D4D4D,#121212,#00000000,#00000000,#262626,#00ac8d,#ff8f00,#3f3f3f,#262626,#1e1e1e8F,#ffb800,#1e1e1e;default,back_logo,one,none,shadow_drop,shadow_drop',
    },
    {
      id: 'simple_purple',
      owner: 'Annuit20',
      conf: '#ff8f00,#5ab966,#5ab966,#3b809b,#F03C3C,#FFA83D,#59D167,#f55353,#DDC056,#E6BB47,#D8813B,#CD7C32,#C22929,#B41E1E,#AB81D8,#41008F,#283ac4,#4f4f4f,#08ab27,#8b0901,#00ac8d,#23b5ef,#1e1e1e,#1e1e1e,#f5f5f5,#121212,#f5f5f5,#cfcfcf,#1e1e1e,#2f2f2f,#141414,#1EC39C00,#00000000,#4D4D4D,#121212,#00000000,#00000000,#262626,#00ac8d,#ff8f00,#3f3f3f,#262626,#1e1e1e8F,#ffb800,#1e1e1e;default_big_symbol,back_logo,two,none,shadow_drop,shadow_drop',
    },

    {
      id: 'sunset',
      // owner: 'GTO Wizard',
      owner: 'meadowstream',
      conf: '#2A75A5,#5AB966,#129683,#888787,#CB0303,#FFFC6B,#00C925,#F55353,#f55353,#e14c4c,#ce4646,#ba3f3f,#a73838,#933232,#7f2b2b,#6c2525,#0481C0,#424242,#258337,#8b0901,#00ac8d,#23b5ef,#1e1e1e,#1e1e1e,#f5f5f5,#121212,#f5f5f5,#cfcfcf,#1e1e1e,#2f2f2f,#1296830C,#12968327,#DF565619,#DF5656B9,#12121200,#00000000,#00000000,#383838FF,#5AB966,#DF5656,#383838,#262626,#2E2E2E70,#ffb800,#1e1e1e;default_big_symbol,back_logo,two,cloud,shadow_drop,shadow_drop',
    },
    {
      id: 'autumn_leaves',
      owner: 'meadowstream',
      conf: '#8D773D,#406340,#A9AA72,#757575,#CB0303,#FFFC6B,#00C925,#f55353,#FF8C00,#A85E04,#C34920,#97250C,#BD2E04,#631D0F,#352508,#251405,#0481C0,#424141,#258337,#8b0901,#1A5E25,#276179,#1e1e1e,#1e1e1e,#f5f5f5,#121212,#f5f5f5,#cfcfcf,#1e1e1e,#2f2f2f,#40634025,#A9AA7268,#FF8C0025,#C34920FF,#121212F2,#00000000,#00000000,#4B4B4BFF,#406340,#FF8C00,#4B4B4B,#262626,#A9AA721F,#ffb800,#1e1e1e;default_big_symbol,back_logo,two,herringbone,shadow_drop,shadow_drop',
    },
    {
      id: 'hot_pink',
      owner: 'Wattsy',
      conf: '#ff8f00,#32CD32,#5ab966,#A9A9A9,#CB0303,#FFFC6B,#00C925,#FF69B4,#FF69B4,#EB61A6,#d65897,#c25089,#ad477a,#993f6c,#85375e,#702e4f,#283ac4,#4f4f4f,#08ab27,#8b0901,#00ac8d,#23b5ef,#1e1e1e,#1e1e1e,#f5f5f5,#121212,#f5f5f5,#cfcfcf,#1e1e1e,#2f2f2f,#FF69B40F,#A9A9A940,#1212125F,#702E4FFF,#12121200,#00000000,#00000000,#494949FF,#32CD32,#FF69B4,#494949,#262626,#A9A9A919,#ffb800,#1e1e1e;default_big_symbol,back_logo,two,cube,shadow_drop,shadow_drop',
    },

    // TRAINER ------------------------------------------------------------
    {
      id: 'default',
      onlyTrainer: true,
      conf: '#ff8f00,#5ab966,#5ab966,#3D7CB8,#F03C3C,#FFA83D,#59D167,#F03C3C,#f03c3c,#dd3737,#ca3232,#b62e2e,#a32929,#902424,#7d1f1f,#6a1a1a,#2235C5,#504F4F,#0EAD2C,#AD0E04,#25B336,#97EAF8,#1e1e1e,#1e1e1e,#f5f5f5,#121212,#f5f5f5,#cfcfcf,#1e1e1e,#464646,#141414,#1EC39C00,#00000000,#4D4D4D,#121212,#00000000,#00000000,#262626,#00ac8d,#ff8f00,#3f3f3f,#262626,#1e1e1e8F,#ffb800,#1e1e1e;default_big_symbol,back_logo,two,none,shadow_drop,shadow_drop',
    },
    {
      id: 'aqua',
      onlyTrainer: true,
      conf: '#ECA139,#65E3DB,#65E3DB,#2A75D9,#459BDF,#7DC9B8,#65E3DB,#459BDF,#459BDF,#3F8FCD,#3a82bb,#3476a9,#2f6998,#295d86,#245174,#1e4462,#283ac4,#4f4f4f,#08ab27,#8b0901,#85D8EB,#2A75D9,#1e1e1e,#1e1e1e,#f5f5f5,#121212,#f5f5f5,#cfcfcf,#1e1e1e,#2f2f2f,#65E3DB12,#65E3DB35,#2A75D92C,#2A75D9FF,#2A75D900,#00000000,#00000000,#262626FF,#00ac8d,#ff8f00,#3f3f3f,#262626,#459BDF15,#ffb800,#1e1e1e;default_big_symbol,back_plain,one,wavy,shadow_drop,shadow_drop',
    },
    {
      id: 'toxic',
      onlyTrainer: true,
      conf: '#FAD02A,#75BB63,#75BB63,#5D5ACC,#DE453E,#FADC62,#75BB63,#DE453E,#de453e,#cc3f39,#ba3a34,#a9342f,#972f2a,#852925,#732420,#621e1b,#283ac4,#4f4f4f,#08ab27,#8b0901,#DE453E,#918EEB,#1e1e1e,#1e1e1e,#f5f5f5,#121212,#f5f5f5,#cfcfcf,#1e1e1e,#2f2f2f,#FFFFFF01,#00000000,#DE453E4E,#DE453E,#121212,#00000000,#00000000,#262626FF,#75BB63,#DE453E,#3f3f3f,#262626,#191919E8,#ffb800,#1e1e1e;default_big_symbol,back_plain,one,herringbone,shadow_drop,shadow_drop',
    },
    {
      id: 'lego',
      onlyTrainer: true,
      conf: '#FFD00E,#6FE361,#6FE361,#4281E1,#D8493B,#E8E057,#6FE361,#D8493B,#d8493b,#c74336,#b53d32,#a4372d,#933228,#822c23,#70261f,#5f201a,#283ac4,#4f4f4f,#08ab27,#8b0901,#5AC249,#60C7E4,#1e1e1e,#1e1e1e,#f5f5f5,#121212,#f5f5f5,#cfcfcf,#1e1e1e,#2f2f2f,#FFFFFF01,#6FE361,#D8493BB8,#4281E1FF,#12121200,#00000000,#00000000,#5A5A5AE4,#00ac8d,#ff8f00,#3f3f3f,#262626,#59BB4D11,#ffb800,#1e1e1e;default_big_symbol,back_plain,one,maya,shadow_drop,shadow_drop',
    },
    {
      id: 'dark',
      onlyTrainer: true,
      conf: '#FF8D21,#3D9969,#3D9969,#07229C,#C20E08,#FF8D21,#3D9969,#C20E08,#c20e08,#b20d07,#a30c07,#930b06,#840a05,#740805,#650704,#550604,#283ac4,#4f4f4f,#08ab27,#8b0901,#24AD66,#071457,#1e1e1e,#1e1e1e,#f5f5f5,#121212,#f5f5f5,#cfcfcf,#1e1e1e,#2f2f2f,#FFFFFF01,#07229C64,#3D996952,#3D9969,#121212,#00000000,#00000000,#262626,#00ac8d,#ff8f00,#3f3f3f,#262626,#FF8D211E,#ffb800,#1e1e1e;default_big_symbol,back_plain,one,stars,shadow_drop,shadow_drop',
    },
    {
      id: 'minimalist',
      onlyTrainer: true,
      conf: '#1EC39C,#3B3B3B,#3B3B3B,#2A2A2A,#8B8B8B,#5F5F5F,#1EC39C,#1EC39C,#1ec39c,#1cb390,#19a483,#179477,#14856a,#12755e,#106551,#0d5645,#283ac4,#4f4f4f,#08ab27,#8b0901,#D8D8D8,#080808,#1e1e1e,#1e1e1e,#f5f5f5,#121212,#f5f5f5,#cfcfcf,#1e1e1e,#2f2f2f,#141414,#1EC39C58,#00000000,#7C7C7C,#121212,#00000000,#00000000,#262626,#00ac8d,#D8D8D8,#3f3f3f,#262626,#1EC39C34,#ffb800,#1e1e1e;default_big_symbol,back_plain,one,none,shadow_drop,shadow_drop',
    },
    {
      id: 'forest',
      onlyTrainer: true,
      conf: '#7DC9B8,#6FB89B,#6FB89B,#1B2627,#529163,#7DC9B8,#6FB89B,#529163,#529163,#4b855b,#457a53,#3e6e4b,#386343,#31573b,#2b4b33,#24402c,#283ac4,#4f4f4f,#08ab27,#8b0901,#6FB89B,#1B2627,#1e1e1e,#1e1e1e,#f5f5f5,#121212,#f5f5f5,#cfcfcf,#1e1e1e,#2f2f2f,#000000,#1EC39C00,#5291636B,#6FB89B,#121212,#00000000,#00000000,#262626,#00ac8d,#ff8f00,#3f3f3f,#262626,#52916330,#ffb800,#1e1e1e;default_big_symbol,back_plain,one,trianglemadness,shadow_drop,shadow_drop',
    },
    {
      id: 'late_night',
      onlyTrainer: true,
      conf: '#EFD266,#AAEF66,#AAEF66,#6AA1D0,#E98D8A,#EFD266,#AAEF66,#E98D8A,#e98d8a,#d6827f,#c47674,#b16b69,#9e605e,#8c5553,#794948,#673E3D,#283ac4,#4f4f4f,#08ab27,#8b0901,#9CCBF0,#6AA1D0,#1e1e1e,#1e1e1e,#f5f5f5,#121212,#f5f5f5,#cfcfcf,#1e1e1e,#2f2f2f,#301B1A,#673E3DB3,#E98D8A9C,#AAEF66,#121212,#00000000,#00000000,#636363,#6AA1D0,#EFD266,#3f3f3f,#262626,#E98D8A15,#ffb800,#1e1e1e;default_big_symbol,back_plain,one,scales,shadow_drop,shadow_drop',
    },
    {
      id: 'vibes',
      onlyTrainer: true,
      conf: '#E1B13C,#48A78B,#48A78B,#3B8D96,#DD7481,#D6574A,#48A78B,#D6574A,#d6574a,#c55044,#b4493e,#a34238,#923b32,#80342c,#6f2d26,#5e2621,#283ac4,#4f4f4f,#08ab27,#8b0901,#73B8A3,#267780,#1e1e1e,#1e1e1e,#f5f5f5,#121212,#f5f5f5,#cfcfcf,#1e1e1e,#2f2f2f,#141414,#E1B13C8D,#E1B13C61,#E1B13C,#12121200,#00000000,#00000000,#E1B13C4B,#48A78B,#D6574A,#E1B13C,#684A01,#E1B13C1C,#ffb800,#1e1e1e;default_big_symbol,back_plain,one,herringbone,shadow_drop,shadow_drop',
    },
    {
      id: 'safari',
      onlyTrainer: true,
      conf: '#FCD00F,#0C8BFE,#0C8BFE,#114BF5,#E20001,#FCD00F,#114BF5,#E20001,#e20001,#d00001,#be0001,#ac0001,#9a0001,#880001,#760001,#630000,#283ac4,#4f4f4f,#08ab27,#8b0901,#4BB2FF,#114BF5,#1e1e1e,#1e1e1e,#f5f5f5,#121212,#f5f5f5,#cfcfcf,#1e1e1e,#2f2f2f,#4E694A,#1EC39C00,#193815AD,#456D3FFF,#121212,#00000000,#00000000,#363636,#0C8BFE,#FCD00F,#E20001,#630000,#1E1E1E60,#ffb800,#1e1e1e;default_big_symbol,back_plain,one,safari,shadow_drop,shadow_drop',
    },
  ].map(i => {
    let colors = ''
    let styles = ''
    const stylesStartIndex = i.conf.indexOf(';')
    if (stylesStartIndex === -1) {
      colors = i.conf
    } else {
      colors = i.conf.substring(0, stylesStartIndex)
      styles = i.conf.substring(stylesStartIndex + 1)
    }
    const r = {
      ...i,
      owner: i.owner || '',
      onlyTrainer: i.onlyTrainer || false,
      // default: !i.owner,
      colors: colors.split(','),
      styles: styles.split(','),
      // ...trainerTableColors(),
    }
    return r
  })
  // console.log(res)
  // console.log(res.map(i => ({ ...i, conf: `${i.colors.join(',')};${i.styles.join(',')}` })))
  return res
}

function getColorTheme(colors) {
  const keys = getColorPalleteKeys()
  const res = {}
  // let colors = customPalette || colorPalettes()[index].colors
  keys.forEach((key, idx) => {
    res[key] = colors[idx]
  })
  // console.log(keys, res)
  return res
}

function getStyleTheme(styles) {
  let res = {}
  const ss = apiStylesDict()
  Object.keys(ss).forEach((key, idx) => {
    const valKey = ss[key].feKey
    res = {
      ...res,
      ...(styles[idx] ? { [valKey]: styles[idx] } : {}),
    }
  })
  return res
}

export { colorPalettes, getColorTheme, getColorPalleteKeys, getStyleTheme }
